import React, { useContext } from "react";
import { Link } from "react-router-dom";
import BottomBar from "../components/BottomBar";
import { StateContext } from "../context/StateProvider";
import useGoogleSearch from "../hooks/useGoogleSearch";
import response from "../response";
import "./SearchPage.css";
import Search from "../components/Search";
import { Avatar } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import SearchIcon from "@mui/icons-material/Search";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import ImageIcon from "@mui/icons-material/Image";
import FeedIcon from "@mui/icons-material/Feed";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import logo from "../assets/icons/appsMenu.svg";
function SearchPage() {
  const [{ term }, dispatch] = useContext(StateContext);
  const { data } = useGoogleSearch(term);
  return (
    <div className="searchPage">
      <div className="searchPage__header">
        <div className="searchPage__headerContent">
          <div className="row1">
            <Link to="/">
              <img
                className="searchPage_logo"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/368px-Google_2015_logo.svg.png"
                alt=""
              />
            </Link>

            <div className="searchPage__headerBody">
              <Search hideButtons={true} userInput={term} />
            </div>
            <div className="searchPage_rightHeader">
              <SettingsIcon sx="padding-right: 20px;" />
              <Avatar />
            </div>
          </div>
          <div className="row2">
            <div className="searchPage__options">
              <div className="searchPage_optionsLeft">
                <div className="searchPage_option">
                  <SearchIcon />
                  <Link to="/all">All</Link>
                </div>

                <div className="searchPage_option">
                  <ImageIcon />
                  <Link to="/images">Images</Link>
                </div>

                <div className="searchPage_option">
                  <OndemandVideoIcon />
                  <Link to="/videos">Videos</Link>
                </div>

                <div className="searchPage_option">
                  <FeedIcon />
                  <Link to="/feed">Books</Link>
                </div>

                <div className="searchPage_option">
                  <MoreVertIcon />
                  <Link to="">More</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="searchPage__results">
        <div className="searchPage_resultsCount">
          <div>
            About {data?.searchInformation.formattedTotalResults} results (
            {data?.searchInformation.searchTime})
            {data?.items.map((item) => {
              return (
                <div className="searchPage__card">
                  <a className="searchPage_result" href={item.link}>
                    {item.pagemap?.cse_image?.length > 0 &&
                      item.pagemap?.cse_image[0].src && (
                        <img
                          className="searchPage__imageResult"
                          src={item.pagemap?.cse_image[0].src}
                        />
                      )}
                    {item.displayLink}
                  </a>
                  <a className="searchPage_resultTitle" href={item.link}>
                    <h2>{item.title} </h2>
                  </a>
                  <p className="searchPage_resultSnippet">{item.snippet}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchPage;
